import { useContext } from "react";
import { ApiContext } from "../contexts/ApiContext";
import { useMutation } from "react-query";
import { ResultFileUpload } from "../shared/interfaces/Result";

export function useResultFileUpload() {
  const apiContext = useContext(ApiContext);
  return useMutation(["uploadResultFile"], async (resultFile: ResultFileUpload) =>
    apiContext.resultsApis.uploadResultFile(resultFile),
  );
}
